import type { SocialInboxMessage } from '@/components/pages/conversations/SocialInbox/types';

class SocialInboxService {
    updateMessagesInDataSource = (
        previousData: any[],
        updatedMessages: SocialInboxMessage[],
        dataKey: string
    ) => {
        return previousData.map((page) => ({
            ...page,
            [dataKey]: page[dataKey]?.map((msg: SocialInboxMessage) => {
                const updatedItem = updatedMessages.find((item) => item.id === msg.id);
                return updatedItem ? { ...msg, ...updatedItem } : msg;
            })
        }));
    };
}

const socialInboxService = new SocialInboxService();

export { socialInboxService as SocialInboxService };
